// DatabaseContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

export const DatabaseContext = createContext();

export const useDatabase = () => {
  const context = useContext(DatabaseContext);

  if (!context) {
    throw new Error('useDatabase must be used within a DatabaseProvider');
  }

  return context;
};

export const DatabaseProvider = ({ children }) => {

  const [activeDatabase, setActiveDatabase] = useState(null);
  const [lastViewKeyByDatabase, setLastViewKeyByDatabase] = useState({});

  const value = useMemo(() => ({
    activeDatabase,
    setActiveDatabase,
    lastViewKeyByDatabase,
    setLastViewKeyByDatabase,
  }), [activeDatabase, lastViewKeyByDatabase]);

  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
};
